import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { OrderRequest } from "./OrderRequest";
import { useNavigate } from "react-router-dom";

function Order({ theme, setOrderStatus, username }) {
  const [active, setActive] = useState(false);
  const { t } = useTranslation();

  const [amountInputValue, setAmountInputValue] = useState("");
  const [discriptionInputValue, setDiscriptionInputValue] = useState("");

  const [requestStatus, setRequestStatus] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setActive(true);
  }, []);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setOrderStatus(false);
          }, 150);
        }}
      ></div>

      <div className={`popupMainDiv ${theme} ${active && "active"}`}>
        <div className="inputDiv">
          <div>{t("Amount")}</div>
          <input
            className={`input dir_ltr ${theme}`}
            onChange={(e) => {
              setAmountInputValue(e.target.value);
            }}
          ></input>
        </div>

        <div className="inputDiv">
          <div>{t("Discription")}</div>
          <textarea
            className={`textarea ${theme}`}
            onChange={(e) => {
              setDiscriptionInputValue(e.target.value);
            }}
          ></textarea>
        </div>

        <button
          className={`submitButton ${theme} ${amountInputValue.length > 0 && discriptionInputValue.length > 0 && "active"}`}
          onClick={() => {
            if (
              amountInputValue.length > 0 &&
              discriptionInputValue.length > 0
            ) {
              OrderRequest(
                username,
                amountInputValue,
                discriptionInputValue,
                setRequestStatus,
                setActive,
                setOrderStatus,
                navigate,
              );
            }
          }}
        >
          {requestStatus ? (
            <img src="/icons/loading.png" className="rotate"></img>
          ) : (
            t("Submit")
          )}
        </button>
      </div>
    </>
  );
}

export default Order;
